import { useTranslation } from 'react-i18next';

import { EMAIL_TEMPLATE_PICKER_DATA } from '@work4all/components/lib/components/entity-picker/email-template-picker/EmailTemplatePicker';

import { useEntityEvents } from '@work4all/data/lib/entity-events/use-entity-events';

import { EMailTemplate } from '@work4all/models/lib/Classes/EMailTemplate.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/eMailTemplate-table-schema.json';

const defaultSort = [{ field: 'name', direction: SortDirection.ASCENDING }];

export function EmailTemplateTable(props: IEntityTableV8) {
  const { prefilter: originalPrefilter, ...rest } = props;

  const { t } = useTranslation();

  const prefilter = [
    { parentId: { $eq: null } },
    ...(originalPrefilter ? originalPrefilter : []),
  ];

  const dataTable = useEntityDataTableV8<EMailTemplate, Record<string, never>>({
    ...rest,
    layout: 'table',
    prefilter,
    schema: schema as never,
    defaultSort,
    cells: {
      Context: (cell) => <>{t(`E_MAIL_TEMPLATE_KIND.${cell.value}`)}</>,
    },
    // When used as picker then we need to pass more data
    forceRequestFields: props.onRowsSelected
      ? EMAIL_TEMPLATE_PICKER_DATA
      : undefined,
  });

  useEntityEvents((event) => {
    if (event.entity === Entities.eMailTemplate) {
      dataTable.refetch();
    }
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
